// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__xf1cn","balanceDisclaimer":"posDashboard_balanceDisclaimer__NqizE"};